<div class="container mb-pdp-tab-content mb-product-resources-tab"
     data-cy="mb-product-resources-tab"
     *ngIf="product$ | async as product">

  <div *ngIf="resources$ | async as resources"
       class="mb-pdp-tab-wrapper mb-resources-wrapper">
    <div class="row no-gutters">
      <div class="col-12 mb-resources-headline-text"
           data-cy="mb-resources-heading">
        {{'mbProductTabs.resourcesFor' | mbTranslate}}
        <span class="mb-resources-text-bold" [innerHTML]="productName | safeHtml"> </span>
      </div>
    </div>
    <div class="row no-gutters">

      <!-------------------Documents and Protocols------------------------>
      <ng-container *ngIf="resources.docsAndProtocols && resources.docsAndProtocols.length">
        <div class="col-12 mb-resources-sub-headline"
             data-cy="mb-resources-documents-headline">{{'mbProductTabs.documentsAndProtocols' | mbTranslate}}
        </div>
        <ng-container *ngFor="let docProtocol of sortBySortOrder(resources.docsAndProtocols); index as i">
          <div class="col-12 mb-resources-content"
               data-cy="mb-resources-doc-protocol-content">
            <div class="mb-resources-docs row no-gutters">
              <div *ngIf="docProtocol.longUrl"
                   class="mb-docs-long-name col-12 col-sm order-1 order-sm-0"
                   [attr.data-cy]="'mb-resources-doc-protocol-link-' + i"
                   [innerHTML]="docProtocol.longUrl | safeHtml"
                   [attr.data-tagname]="docProtocol.tagName"
                   mbCmsInnerHTML
              ></div>
              <div *ngIf="docProtocol.tagName"
                   class="col-12 col-sm order-0 order-sm-1">
                <span class="mb-docs-tag-name"
                      [attr.data-cy]="'mb-resources-doc-protocol-tag-name-' + i"
                      [innerHTML]="docProtocol.tagName | safeHtml"></span>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-------------------Certificates------------------------>
      <ng-container *ngIf="resources.certificates && resources.certificates.length">
        <div class="col-12 mt-4 mb-resources-sub-headline"
             data-cy="mb-resources-certificate-headline">{{'mbProductTabs.certificates' | mbTranslate}}
        </div>
        <ng-container *ngFor="let certificate of resources.certificates; index as i">
          <div *ngIf="certificate.text"
               class="mb-resources-certificate-content"
               [innerHTML]="certificate.text | safeHtml"
               [attr.data-cy]="'mb-resources-certificates-text-' + i">
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
